import React, { useState } from 'react';
import { Box, Grow, Typography } from '@material-ui/core';
import { useDashboardSummary } from '../dashboardSummaryContext';
import Skeleton from '@yisheng90/react-loading';
import MinimizeRoundedIcon from '@material-ui/icons/MinimizeRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import UnfoldMoreRoundedIcon from '@material-ui/icons/UnfoldMoreRounded';
import { Alert } from '@material-ui/lab';
import ReactMarkdown from 'react-markdown';

const AIPopup: React.FC = () => {
  const { loadingSummary, showPopup, dashboardSummary, setShowPopup, errorLoadingSummary } = useDashboardSummary();
  const [isMinimizedPopup, setIsMinimizedPopup] = useState<boolean>(false);

  return (
    <Grow in={showPopup} timeout={500}>
      <Box className={`ai-popper ${isMinimizedPopup ? 'minimezed-popup' : ''}`}>
        <Box className='ai-icons-header'>
          <Typography className='ai-header'>Dashboard Summary</Typography>
          <Box className='ai-icons-wrapper'>
            <Box className='ai-icon' onClick={() => setIsMinimizedPopup(true)}>
              <MinimizeRoundedIcon fontSize='small' />
            </Box>
            <Box className='ai-icon' onClick={() => setIsMinimizedPopup(false)}>
              <UnfoldMoreRoundedIcon fontSize='small' className='ai-expand-icon' />
            </Box>
            <Box className='ai-icon' onClick={() => setShowPopup && setShowPopup(false)}>
              <CloseRoundedIcon fontSize='small' />
            </Box>
          </Box>
        </Box>
        {!isMinimizedPopup ? (
          <Box className='ai-content'>
            {loadingSummary ? (
              <>
                <Skeleton rows={1} height={20} width='50%' />
                <Box className='ai-skeleton'>
                  <Skeleton rows={3} height={16} width='100%' />
                  <Skeleton rows={1} height={16} width='30%' />
                </Box>
              </>
            ) : (
              dashboardSummary ? (
                <ReactMarkdown>{dashboardSummary}</ReactMarkdown>
              ) : errorLoadingSummary ? (
                <Alert severity='error'>Error loading dashboard summary</Alert>
              ) : null
            )}
          </Box>
        ) : null}
      </Box>
    </Grow>
  )
}

export default AIPopup;